/**
 * 裁剪头像上传
 */
import React, { Component } from 'react';
import axios from 'axios';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import Button from '../button';
import Icon from '../icon';
import Modal from '../modal';
import message from '../message';
import Upload from '../upload';
import Crop from './Crop';
import { getPrefixCls } from '../configure';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale-provider/default';
const Dragger = Upload.Dragger;
const { round } = Math;
function rotateFlag(rotate) {
    return (rotate / 90) % 2 !== 0;
}
let Avatarlocale = defaultLocale.imageCrop;
export default class AvatarUploader extends Component {
    constructor(props) {
        super(props);
        this.handleOk = () => {
            const { x, y, size, rotate, file, imageStyle: { width, height }, img: { naturalWidth } } = this.state;
            const { uploadUrl, uploadFaild, uploadError, handleUpload, axiosConfig } = this.props;
            const flag = rotateFlag(rotate);
            const scale = naturalWidth / width;
            const startX = flag ? x - ((width - height) / 2) : x;
            const startY = flag ? y + ((width - height) / 2) : y;
            const QsData = {
                rotate,
                startX: round(startX * scale),
                startY: round(startY * scale),
                endX: round(size * scale),
                endY: round(size * scale),
            };
            const qs = JSON.stringify(QsData);
            const data = new FormData();
            data.append('file', file);
            this.setState({ submitting: true });
            if (uploadUrl) {
                let config;
                if (axiosConfig) {
                    config = axiosConfig;
                }
                axios.post(`${uploadUrl}?${qs}`, data, config)
                    .then((res) => {
                    // @ts-ignore
                    if (res.success) {
                        this.uploadOk(res);
                    }
                    else {
                        message.error(Avatarlocale.avatarUploadError);
                        this.setState({ submitting: false });
                        if (uploadFaild) {
                            uploadFaild();
                        }
                    }
                })
                    .catch((error) => {
                    message.error(`${Avatarlocale.avatarServerError}${error}`);
                    this.setState({ submitting: false });
                    if (uploadError) {
                        uploadError(error);
                    }
                });
            }
            if (handleUpload) {
                QsData.file = file;
                handleUpload(QsData);
            }
        };
        this.handleCancel = () => {
            this.close();
        };
        const { defaultRectSize } = props;
        this.state = {
            submitting: false,
            img: null,
            file: '',
            imageStyle: { width: 0, height: 0 },
            size: defaultRectSize,
            x: 0,
            y: 0,
            rotate: 0,
        };
    }
    close() {
        const { onClose } = this.props;
        this.setState({
            img: null,
        });
        if (onClose) {
            onClose(false);
        }
    }
    uploadOk(res) {
        const { onUploadOk } = this.props;
        this.setState({
            img: null,
            submitting: false,
        }, () => {
            if (onUploadOk) {
                onUploadOk(res);
            }
        });
    }
    initImageSize(img, rotate = 0) {
        const { editorWidth, editorHeight, minRectSize, defaultRectSize } = this.props;
        const { naturalWidth, naturalHeight } = img;
        const flag = rotateFlag(rotate);
        let width = flag ? naturalHeight : naturalWidth;
        let height = flag ? naturalWidth : naturalHeight;
        if (width < minRectSize || height < minRectSize) {
            if (width > height) {
                width = (width / height) * minRectSize;
                height = minRectSize;
            }
            else {
                height = (height / width) * minRectSize;
                width = minRectSize;
            }
        }
        else if (width > editorWidth || height > editorHeight) {
            if (width / editorWidth > height / editorHeight) {
                height = (height / width) * editorWidth;
                width = editorWidth;
            }
            else {
                width = (width / height) * editorHeight;
                height = editorHeight;
            }
        }
        if (flag) {
            const tmp = width;
            width = height;
            height = tmp;
        }
        const size = Math.min(defaultRectSize, width, height);
        this.setState({
            img,
            imageStyle: {
                width,
                height,
                top: (editorHeight - height) / 2,
                left: (editorWidth - width) / 2,
                transform: `rotate(${rotate}deg)`,
            },
            size,
            x: (width - size) / 2,
            y: (height - size) / 2,
            rotate,
        });
    }
    onComplete(imageState) {
        const { cropComplete } = this.props;
        this.setState(imageState);
        if (cropComplete) {
            cropComplete(imageState);
        }
    }
    loadImage(src) {
        if (typeof window !== 'undefined') {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                this.initImageSize(img);
            };
        }
    }
    getPreviewProps(previewSize) {
        const { size, x, y, img: { src }, rotate, imageStyle: { width, height } } = this.state;
        const previewScale = previewSize / size;
        let radius = (rotate % 360) / 90;
        let px = -x;
        let py = -y;
        if (radius < 0)
            radius += 4;
        if (radius === 1) {
            py = ((x + ((height - width) / 2)) - height) + size;
            px = ((height - width) / 2) - y;
        }
        else if (radius === 2) {
            px = (x - width) + size;
            py = (y - height) + size;
        }
        else if (radius === 3) {
            px = ((y + ((width - height) / 2)) - width) + size;
            py = ((width - height) / 2) - x;
        }
        return {
            style: {
                width: previewSize,
                height: previewSize,
                backgroundImage: `url('${src}')`,
                backgroundSize: `${width * previewScale}px ${height * previewScale}px`,
                backgroundPosition: `${px * previewScale}px ${py * previewScale}px`,
                transform: `rotate(${rotate}deg)`,
            },
        };
    }
    renderPreviewItem(previewSizeList) {
        const { prefixCls: customizePrefixCls } = this.props;
        const prefixCls = getPrefixCls('avatar-crop-edit', customizePrefixCls);
        const dataList = previewSizeList.map((itemSize) => {
            return (React.createElement("div", { key: itemSize, className: `${prefixCls}-preview-item` },
                React.createElement("i", Object.assign({}, this.getPreviewProps(itemSize))),
                React.createElement("p", null, `${itemSize}＊${itemSize}`)));
        });
        return dataList;
    }
    renderEditor(props) {
        const { img, file, rotate } = this.state;
        const { prefixCls: customizePrefixCls, previewList, editorWidth, editorHeight, defaultRectSize, minRectSize, subTitle, previewTitle, reloadTitle } = this.props;
        const { src } = img;
        const prefixCls = getPrefixCls('avatar-crop-edit', customizePrefixCls);
        const previewTitleFlag = isString(previewTitle) || React.isValidElement(previewTitle);
        const renderPreviewTitle = () => {
            if (!previewTitleFlag || !previewTitle)
                return null;
            if (isString(previewTitle)) {
                return (React.createElement("h5", { className: `${prefixCls}-preview-title` },
                    React.createElement("span", null, previewTitle)));
            }
            return previewTitle;
        };
        return (React.createElement("div", null,
            React.createElement("h3", { className: `${prefixCls}-text` },
                React.createElement("span", null, subTitle || Avatarlocale.avatarUpload),
                React.createElement(Icon, { type: "keyboard_arrow_right" }),
                React.createElement("span", null, file.name)),
            React.createElement("h4", { className: `${prefixCls}-hint` },
                React.createElement("span", null, Avatarlocale.avatarReminder)),
            React.createElement("div", { className: `${prefixCls}-wraper` },
                React.createElement(Crop, { defaultRectSize: defaultRectSize, minRectSize: minRectSize, editorHeight: editorHeight, editorWidth: editorWidth, rotation: rotate, src: src, onComplete: (stateImage) => this.onComplete(stateImage) }),
                React.createElement("div", { className: `${prefixCls}-toolbar` },
                    React.createElement(Button, { icon: "replay_90", shape: "circle", onClick: () => this.setState({ rotate: rotate - 90 }) }),
                    React.createElement(Button, { icon: "play_90", shape: "circle", onClick: () => this.setState({ rotate: rotate + 90 }) })),
                React.createElement("div", { className: `${prefixCls}-preview` },
                    renderPreviewTitle(),
                    this.renderPreviewItem(previewList))),
            React.createElement("div", { className: `${prefixCls}-button` },
                React.createElement(Upload, Object.assign({}, props),
                    React.createElement(Button, { icon: "file_upload", type: "primary" },
                        React.createElement("span", null, reloadTitle || Avatarlocale.reUpload))))));
    }
    getUploadProps() {
        const { limit: { size: limitSize, type }, uploadProps } = this.props;
        const typeLimit = type.split(',').map((item) => `image/${item}`).join(',');
        return {
            multiple: false,
            name: 'file',
            accept: typeLimit,
            headers: {
                Authorization: `bearer`,
            },
            showUploadList: false,
            ...uploadProps,
            beforeUpload: (file) => {
                const { size } = file;
                if (size > limitSize * 1024) {
                    message.warning(Avatarlocale.imageTooLarge);
                    return false;
                }
                this.setState({ file });
                const windowURL = window.URL || window.webkitURL;
                if (windowURL && windowURL.createObjectURL) {
                    this.loadImage(windowURL.createObjectURL(file));
                    return false;
                }
                return false;
            },
            onChange: ({ file }) => {
                const { status, response } = file;
                if (status === 'done') {
                    this.loadImage(response);
                }
                else if (status === 'error') {
                    message.error(Avatarlocale.imageUploadError);
                }
            },
        };
    }
    renderContainer() {
        const { prefixCls: customizePrefixCls, limit: { size: limitSize, type } } = this.props;
        const { img } = this.state;
        const prefixCls = getPrefixCls('avatar-crop', customizePrefixCls);
        const props = this.getUploadProps();
        return img ? (this.renderEditor(props)) :
            (React.createElement(Dragger, Object.assign({ className: `${prefixCls}-dragger` }, props),
                React.createElement(Icon, { type: "inbox" }),
                React.createElement("h3", { className: `${prefixCls}-dragger-text` },
                    React.createElement("span", null, Avatarlocale.imageDragHere)),
                React.createElement("h4", { className: `${prefixCls}-dragger-hint` },
                    React.createElement("span", null, `${Avatarlocale.pleaseUpload}${limitSize / 1024}M,${Avatarlocale.uploadType}${type}${Avatarlocale.picture}`))));
    }
    render() {
        const { visible, modalProps, title } = this.props;
        const { img, submitting } = this.state;
        const modalFooter = [
            React.createElement(Button, { disabled: submitting, key: "cancel", onClick: this.handleCancel },
                React.createElement("span", null, Avatarlocale.cancelButton)),
            React.createElement(Button, { key: "save", type: "primary", disabled: !img, loading: submitting, onClick: this.handleOk },
                React.createElement("span", null, Avatarlocale.saveButton)),
        ];
        return (React.createElement(LocaleReceiver, { componentName: "imageCrop", defaultLocale: defaultLocale.imageCrop }, (locale) => {
            Avatarlocale = locale || defaultLocale.imageCrop;
            return (React.createElement(Modal, Object.assign({ title: title || React.createElement("span", null, Avatarlocale.changeAvatar), className: "avatar-modal", visible: visible, width: 980, closable: false, maskClosable: false, footer: modalFooter }, modalProps), this.renderContainer()));
        }));
    }
}
AvatarUploader.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onUploadOk: PropTypes.func,
    limit: PropTypes.object,
    uploadUrl: PropTypes.string,
    previewList: PropTypes.array,
    editorWidth: PropTypes.number,
    editorHeight: PropTypes.number,
    minRectSize: PropTypes.number,
    defaultRectSize: PropTypes.number,
    prefixCls: PropTypes.string,
    handleUpload: PropTypes.func,
    axiosConfig: PropTypes.object,
    cropComplete: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    previewTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    reloadTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    uploadProps: PropTypes.object,
    modalProps: PropTypes.object,
    reloadText: PropTypes.func,
    uploadFaild: PropTypes.func,
    uploadError: PropTypes.func,
};
AvatarUploader.defaultProps = {
    limit: {
        type: 'jpeg,png,jpg',
        size: 1024,
    },
    previewList: [80, 30, 18],
    editorWidth: 540,
    editorHeight: 300,
    minRectSize: 80,
    defaultRectSize: 200,
};
